import axios from 'axios';
import React, { useState } from 'react'
import { FloatingLabel, Form, Row } from 'react-bootstrap';
import Puff from 'react-loading-icons/dist/esm/components/puff';

function StockStatus() {
    const [datefrom,setDateFrom]=useState('');
    const [dateto,setDateTo]=useState('');
    const [isClick,setIsClick]=useState(false);


const handleSubmit=(e)=>{
e.preventDefault();
setIsClick(true);
const data={
'datefrom':datefrom,
'dateto':dateto

}
axios({
  url: 'api/stock/status',
  method: 'POST',
  data:data,
  responseType: 'blob', // important
}).then((response) => {
  const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', 'stockstatus.xlsx'); // or any other filename you prefer
    document.body.appendChild(link);
    link.click();
setIsClick(false);
});

}

  return (
    <div className='row fadeInDown animated'>
       <center>
        <div className='col-md-6 mt-3' style={{boxShadow:'0px 0px 5px 0px #9E9E9E',padding:'18px'}}>

        <div className='co-md-11'>
<h2>STOCK STATUS </h2> <hr/>
            </div>   
       
    <div className='col-md-10 mt-4'>
  
    <FloatingLabel  label="Date From" >
        <Form.Control type="date"  name="datefrom" placeholder='Date From'  value={datefrom} onChange={(e)=>setDateFrom(e.target.value)} />
      </FloatingLabel>
    </div>
    <div className='col-md-10 mt-4'>
  
    <FloatingLabel  label="Date To" >
        <Form.Control type="date"  name="dateto" placeholder='Date To'  value={dateto} onChange={(e)=>setDateTo(e.target.value)} />
      </FloatingLabel>
    </div>
    <div className='col-md-10 mt-4'>

    <Row className='g-1 mt-4'>


<div className='col md'>
<button onClick={(e)=>handleSubmit(e)} className='btn btn-info btn-lg btn-block'>{isClick?  <Puff/>:'Stock Status Report'}  </button>

</div>
    </Row></div>
    </div></center>
    </div>
  )
}

export default StockStatus

